import { render, staticRenderFns } from "./StyledToolTip.vue?vue&type=template&id=3bec5db2"
import script from "./StyledToolTip.vue?vue&type=script&lang=ts"
export * from "./StyledToolTip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports